import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type StatusCounts = {
  approvedCount: number;
  rejectedCount: number;
  waitingCount: number;
};

export const getStatusCounts = () => {
  return api<PcApiResponse<StatusCounts>>('get', `/pc-api/v1/${PREFIX_PATH}/dashboard/svc/status-counts`);
};
